import { ListOfDataListItemResponse } from './Api/ListOfDataListItemResponse';

export class ProjectStateEntity extends ListOfDataListItemResponse {
	public static tryCast(o: any): ProjectStateEntity {
		const ret = new ProjectStateEntity();
		return Object.assign(ret, o);
	}
}
